import Image from 'next/image';
import Wave from './Wave';
import React from 'react';
import { StyledCoverMenu } from './CoverMenu.styled';

export default function CoverMenu({ activity, coverImageSrc, children }) {
  const wave = (
    <Wave
      amplitude={4}
      frequency={14}
      width={70}
      height={10}
      color="white"
      strokeWidth="3"
      className="wave"
    />
  );

  return (
    <StyledCoverMenu
      bgMenuImg={
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
        '/commonGameAssets/classic/menu_background.png'
      }
    >
      <div className="cover-image">
        <Image
          src={coverImageSrc}
          alt="cover image"
          layout="fill"
          objectFit="cover"
        />
        {!activity?.data?.hideTitle && (
          <div className="cover-title-container">
            {wave}
            <div className="cover-title">{activity.name}</div>
            {wave}
            <div className="cover-subtitle">{activity.englishName}</div>
          </div>
        )}
      </div>
      <div className="menu">{children}</div>
    </StyledCoverMenu>
  );
}
